import React from "react";

const ClickStopper = ({ children }) => {
    const stopEvent = (e) => e.stopPropagation();

    return (
        <span onClick={stopEvent} onKeyDown={stopEvent}>
            {children}
        </span>
    );
};

export default ClickStopper;

